import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
import addressDetailsReducer from "./addressSlice";
import bankDetailsReducer from "./bankSlice";
import boidDetailsReducer from "./boidSlice";
import companyDetailSReducer from "./companySlice";
import directorDetailsReducer from "./directorSlice";
import documentSlice from "./documentSlice";
import dynamicFieldDetailsReducer from "./dynamicFieldSlice";
import familyDetailsReducer from "./familySlice";
import guardianDetailsReducer from "./guardianSlice";
import lookupSlice from "./lookupSlice";
import occupationDetailsReducer from "./occupationSlice";
import moneyLaunderingDetailsReducer from "./moneyLaunderingPreventionSlice";
import personalDetailsReducer from "./personSlice";
import routerReducer from "./routerSlice";
import lookupReducer from "./lookupSlice";
import biometricsSlice from "./biometricsSlice";
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  personalDetails: personalDetailsReducer,
  boidDetails: boidDetailsReducer,
  routerData: routerReducer,
  addressDetails: addressDetailsReducer,
  familyDetails: familyDetailsReducer,
  bankDetails: bankDetailsReducer,
  guardianDetails: guardianDetailsReducer,
  occupationDetails: occupationDetailsReducer,
  moneyLaunderingDetails: moneyLaunderingDetailsReducer,
  companyDetails: companyDetailSReducer,
  directorDetails: directorDetailsReducer,
  dynamicFieldDetails: dynamicFieldDetailsReducer,
  documentDetails: documentSlice,
  lookupDetails: lookupReducer,
  biometricsDetailsList: biometricsSlice,
});

function configureStore(preloadedState) {
  const store = createStore(
    rootReducer,
    preloadedState,
    composeEnhancer(applyMiddleware(thunkMiddleware))
  );

  return store;
}

export default configureStore({});
